import { render, staticRenderFns } from "./MovimentacoesMinimas.vue?vue&type=template&id=d8fcd6fc&"
import script from "./MovimentacoesMinimas.vue?vue&type=script&lang=js&"
export * from "./MovimentacoesMinimas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports